module.exports = __webpack_public_path__ + "img/pe.b49d4752.svg";